export var Variant;
(function (Variant) {
    Variant["mtn"] = "mtn";
    Variant["mtd"] = "mtd";
    Variant["gm"] = "gm";
    Variant["fg"] = "fg";
    Variant["eg"] = "eg";
})(Variant || (Variant = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFyaWFudC5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJzdHlsZS92YXJpYW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLE9BTVg7QUFORCxXQUFZLE9BQU87SUFDakIsc0JBQVcsQ0FBQTtJQUNYLHNCQUFXLENBQUE7SUFDWCxvQkFBUyxDQUFBO0lBQ1Qsb0JBQVMsQ0FBQTtJQUNULG9CQUFTLENBQUE7QUFDWCxDQUFDLEVBTlcsT0FBTyxLQUFQLE9BQU8sUUFNbEIifQ==